const TeanatRegisterActionTypes = {
  SET_TENANT: 'SET_TENANT',
  CLEAR_TENANT: 'CLEAR_TENANT',
  SET_TENANT_DOCUMENT: 'SET_TENANT_DOCUMENT',
  ADD_TENANT_TO_LIST: 'ADD_TENANT_TO_LIST',
  SET_TENANT_FULL: 'SET_TENANT_FULL',
}

export default TeanatRegisterActionTypes
